import { gapBetweenSelectedSeatsRuleOptionsValidator } from '@vista-digital/occ-domain';
import { Validator } from '@vista-digital/validator';
export const occSeatingGapBetweenSelectedSeatsRuleConfigValidator = Validator.object({
    enabled: Validator.boolean(),
    options: gapBetweenSelectedSeatsRuleOptionsValidator
});
//# sourceMappingURL=gap-between-selected-seats-rule.js.map